import React, { Component } from 'react';

import primaryStyles from './primary.less';

interface Props {
	dataTestId?: string;
	children: React.ReactNode;
	type: 'submit' | 'reset' | 'button' | null;
	styles: { button: string };
	disabled: boolean;
	tabIndex?: number;
	title?: string;
	buttonRef?(button: HTMLButtonElement | null): void;
	onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export default class Button extends Component<Props> {
	static defaultProps = {
		type: null,
		styles: primaryStyles,
		disabled: false,
		buttonRef: null,
		onClick: null,
	};

	render() {
		const { dataTestId, children, type, styles, disabled, tabIndex, buttonRef, onClick, ...props } = this.props;

		return (
			<button
				className={styles.button}
				data-testid={dataTestId}
				disabled={disabled}
				ref={buttonRef}
				tabIndex={tabIndex}
				type={type || undefined}
				onClick={onClick}
				{...props}
			>
				{children}
			</button>
		);
	}
}
